import {deleteCookie, setCookie} from '@github-ui/cookies'

const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000

/**
 * Writes a dashboard preference cookie. An empty string deletes the cookie so
 * that a cleared preference falls back to the server-provided default rather
 * than pinning an empty value.
 */
export function setPreferenceCookie(name: string, value: string, maxAgeMs: number = ONE_YEAR_MS): void {
  if (value === '') {
    deleteCookie(name)
    return
  }

  setCookie(name, value, new Date(Date.now() + maxAgeMs).toUTCString())
}
